import React, { useEffect, useState } from 'react';
import styles from './GoUpButton.module.scss'
import Button from 'components/Button/Button';
import { ReactComponent as ArrowIcon } from "assets/Imgs/arrow_left.svg";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { PAGES } from 'routes/PAGES';

const THRESHOLD = 1000;

const GoUpButton = () => {
    const [isShown, setIsShown] = useState(false);
    const history = useHistory();
    const isLanding = history.location.pathname === PAGES.WELCOME;

    useEffect(() => {
        const handleScroll = () => {
            setIsShown(window.scrollY > THRESHOLD);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        gtag('event', `go_up_button_click`)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={styles.wrapper}>
            {isShown && !isLanding && (
                <Button
                    style={styles.button}
                    iconOnly
                    rounded
                    icon={<ArrowIcon />}
                    onClick={scrollToTop}
                />
            )}
        </div>
    );
};

export default GoUpButton;
